import { useNavigate } from 'react-router-dom';

export const InfoSection = ({
  className,
  title,
  editPath,
  items,
}: {
  className: string;
  title: string;
  editPath: string;
  items: Array<{ field: string; value: string }>;
}) => {
  const navigate = useNavigate();

  return (
    <div className={className}>
      <div className="flex justify-between">
        <p className="font-sans md:text-center font-medium">{title}</p>
        <span className="cursor-pointer" onClick={() => navigate(editPath)}>
          Edit
        </span>
      </div>
      <div>
        {items.map((item) => (
          <div className="rounded-2xl px-5 py-3 bg-white mt-3">
            <p className="typography-caption1 text-tertiary">{item.field}</p>
            <p>{item.value}</p>
          </div>
        ))}
      </div>
    </div>
  );
};
